import { useContext, useState, useRef, useEffect } from "react";
import { Handle, Position, useUpdateNodeInternals } from "@xyflow/react";
import { StoreContext } from "../../store/Store";
import { GlobalRefContext } from "../../store/GlobalRefs";
import { actionTypes } from "../../store/storeTypes";
import { handleStyles } from "./customNodeStyles";
import { onNodeClick } from "./customNodeFunctions";

export const PlaceholderNode = ({ data }) => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const { flowConfig, showHandles } = store;
  const [selectedHandle, setSelectedHandle] = useState(null);
  const [positions, setPositions] = useState(null);
  const nodeRef = useRef(null);
  const updateNodeInternals = useUpdateNodeInternals();

  useEffect(() => {
    if (data.handles) {
      setPositions({
        target: data.handles.target,
        source: data.handles.source,
      });
    }
  }, [data.handles]);

  const onHandleSelect = (type) => {
    setSelectedHandle(type);
  };

  const onNodeClickWrapper = (ev, button) => {
    onNodeClick(
      ev,
      button,
      selectedHandle,
      nodeRef,
      positions,
      setPositions,
      updateNodeInternals,
      data,
      grefs,
      dispatch,
      actionTypes
    );
  };
  return positions ? (
    <>
      {showHandles && (
        <>
          <div
            style={{
              ...handleStyles()[positions.target],
              backgroundColor: selectedHandle === "target" ? "red" : "orange",
            }}
            onClick={() => onHandleSelect("target")}
          ></div>
          <div
            style={{
              ...handleStyles()[positions.source],
              backgroundColor: selectedHandle === "source" ? "red" : "orange",
            }}
            onClick={() => onHandleSelect("source")}
          ></div>
        </>
      )}
      <div
        ref={nodeRef}
        style={{ ...data.style, width: undefined }}
        onClick={(ev) => onNodeClickWrapper(ev, "")}
      >
        When the selection is made, this is where the first step of the next
        flowchart will appear.
      </div>

      {positions.target && (
        <Handle
          type="target"
          position={Position[positions.target]}
          style={{ backgroundColor: flowConfig.handleBackgroundColor }}
        />
      )}
      {positions.source && (
        <Handle
          type="source"
          position={Position[positions.source]}
          style={{ backgroundColor: flowConfig.handleBackgroundColor }}
        />
      )}
    </>
  ) : null;
};
